<template>
  <div style="background-color: rgb(247, 247, 247);"
    class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <navTeacher></navTeacher>

    <div style="width: 5.2083rem;
    padding:.2604rem .9375rem .5208rem .9375rem;margin: 0 auto;background-color: #fff;">
      <img src="../../assets/Personback.png" alt=""
        style="width: .4167rem;height: .1458rem;position: relative; top: -0.2083rem;left: -0.2604rem;"
        @click="$router.push('/findstudent')">
      <Jianli :did="did"></Jianli>
      <img src="../../assets/teachertoudi.png" alt=""
        style="width: .5067rem;height: .1883rem;margin-top: .1667rem;margin-left: 2.80729rem;" @click="toudi">
    </div>

  </div>
</template>

<script>
import Jianli from '../layout/Tlookstudentjianli.vue'
import navTeacher from '../layout/nav-student.vue';
export default {
  components: {
    Jianli,
    navTeacher
  },
  data() {
    return {
      did: this.$route.hash.slice(1),
      Authorization: ''
    }
  },
  methods: {
    toudi() {
      this.$http.get('/Api/Teacher', {
        headers: {
          'Authorization': this.Authorization
        }
      }).then(() => {
        this.$http.post('/Api/Teacher/Apply/' + this.did, {}, {
          headers: {
            'Authorization': this.Authorization
          }
        }).then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: '投递成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message({
            message: err,
            type: 'warning'
          });
        })
      }).catch(() => {
        this.$message({
          message: '请先完善个人信息',
          type: 'warning'
        });
        this.$router.push('/personteacher/jianli')
      })

    }
  },
  created() {
    this.Authorization = localStorage.getItem('Authorization')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Teacherlook.vue